export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'

export const avatarSizes: Record<AvatarSize, string> = {
  xs: 'tw-w-4 tw-h-4',
  sm: 'tw-w-6 tw-h-6',
  md: 'tw-w-8 tw-h-8',
  lg: 'tw-w-12 tw-h-12',
  xl: 'tw-w-[72px] tw-h-[72px]',
  '2xl': 'tw-w-24 tw-h-24',
  '3xl': 'tw-size-[144px]',
}
